<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
        >
            <b-sidebar id="addContract" aria-labelledby="sidebar-no-header-title" no-header backdrop width="80rem" style="direction:ltr" right title="إضافة ملاحظة" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                        <span>{{lang.add_contract}}</span>
                        </div>
                        <div @click="hide" id="hideContract" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{lang.close}}</span>
                        </div>
                    </div>
                <v-divider></v-divider>
                <v-row style="direction:rtl" class="m-2">
                    <v-col cols="12" sm="12" md="12" lg="12">
                        <div v-if="customer.id == 0 && $store.state.licenseType.showCustomerTypes" class="tobbuttom backBlack" :style="`direction:${ lang.dir};padding:7px;width:100%;text-align:center;`">
                            <b-button :style="`border-radius:0;background:transparent;color:#000;border:none;`">{{ lang.customer_type}}</b-button>
                            <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;margin-inline-end:5px;border:2px solid #fff !important" ref="_cInd" :class="`dispFlex btn btn-small redColor borderRad_`+lang.algin" @click="changeCusType(0)" >{{ lang.individual_client}} <i ref="_indiv"  style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down"></i></b-button>
                            <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;border:2px solid #fff !important" ref="_cCom" :class="`dispFlex btn btn-small weightColor borderRad_none`" @click="changeCusType(1)" >{{ lang.company_clinet}} <i ref="_comps"  style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down hideme"></i></b-button>
                            <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;border:2px solid #fff !important" ref="_cGov" :class="`dispFlex btn btn-small weightColor borderRad_`+lang.lalgin" @click="changeCusType(2)" >{{ lang.government_clinet}} <i ref="_goves" style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down hideme"></i></b-button>
                        </div>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.contract_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="sd.year" :options="$store.state.yearList" />
                        </div>
                        <b-form-input class="inborder"
                            v-model="contract_date"
                            required
                            type="date"
                            style="display:none"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.contract_expire_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="ed.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="ed.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="ed.year" :options="$store.state.yearList" />
                        </div>
                        <b-form-input class="inborder"
                            v-model="expire_date"
                            required
                            type="date"
                            style="display:none;"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.contract_start_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="std.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="std.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="std.year" :options="$store.state.yearList" />
                        </div>
                        <b-form-input class="inborder"
                            v-model="start_date"
                            required
                            style="display:none;"
                            type="date"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.mobile}}</label>
                        <b-form-input class="inborder"
                            v-model="mobile"
                            @change="getCustomer()"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" style="display:none;">
                        <label>{{lang.company_name}}</label>
                        <b-form-input class="inborder"
                            v-model="company_name"
                            value=""
                            readonly
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="!showcamp && !showGov">
                        <label>{{lang.customer_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.full_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.company_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.full_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.crt_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.crt_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.vat_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.vat_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.building_no}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.building_no"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.street_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.street_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.district}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.district"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.city}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.city"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.zipcode}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.zipcode"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.branch_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.branch_no"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" v-if="showcamp">
                        <label>{{lang.address}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.address"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.entity_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.entity_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.branch_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.branch_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.po_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.po_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.po_date}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.po_date"
                            type="date"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.request_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.request_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" v-if="con_type == 1">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack text-center" style="width:150px;">{{ lang.item_code }}</th>
                                    <th class="backBlack text-center">{{ lang.item_name }}</th>
                                    <th class="backBlack text-center" style="width:150px;">{{ lang.item_price }}</th>
                                    <th class="backBlack text-center" style="width:150px;">{{ lang.type }}</th>
                                    <th class="backBlack text-center">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in contract_items" :key="index">
                                    <td style="width:100px;">{{ item.item_code }}</td>
                                    <td>{{ item.item_name }}</td>
                                    <td style="width:150px;">{{ item.item_price }}</td>
                                    <td style="width:150px;">{{ item.type_name[`name_ar`] }}</td>
                                    <td style="cursor:pointer;margin-left: 5px;width:80px;background:red;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:red !important;" @click="deleteItem(index)" v-b-toggle.crm_project_view>{{lang.delete}}</div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th style="padding:2px !important;">
                                        <b-form-input class="inborder"
                                        v-model="new_itesm.item_code"
                                        @change="getItem()"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>{{ new_itesm.item_name }}</th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_itesm.item_price"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        {{ new_itesm.type_name[`name_`+lang.langname] }}
                                    </th>
                                    <td style="cursor:pointer;margin-left: 5px;width:80px;background:green;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:green !important;" @click="addNewItem()">{{lang.add}}</div>
                                    </td>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" v-if="con_type == 1">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack text-center">{{ lang.plate_number }}</th>
                                    <th class="backBlack text-center">{{ lang.brand_name }}</th>
                                    <th class="backBlack text-center">{{ lang.model }}</th>
                                    <th class="backBlack text-center">{{ lang.car_year }}</th>
                                    <th class="backBlack text-center">{{ lang.car_color }}</th>
                                    <th class="backBlack text-center">{{ lang.vin_number }}</th>
                                    <th class="backBlack text-center">{{ lang.meter_car }}</th>
                                    <th class="backBlack text-center">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in contracts_cars" :key="index">
                                    <td>{{ item.plate_number }}</td>
                                    <td>{{ item.brand }}</td>
                                    <td>{{ item.model }}</td>
                                    <td>{{ item.car_year }}</td>
                                    <td>{{ item.color }}</td>
                                    <td>{{ item.vin }}</td>
                                    <td>{{ item.meter_car }}</td>
                                    <td style="margin-left: 5px;width:80px;background:red;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:red !important;" @click="deleteCar(index)">{{lang.delete}}</div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>
                                        <div class="plateNumber p-2">
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.c1" style="width:30px;" />
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.c2" style="width:30px;border-right:none !important" />
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.c3" style="width:30px;border-right:none !important" />
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.text" style="width:60px;border-right:none !important" />
                                        </div>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.brand"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.model"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.car_year"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.color"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.vin"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.meter_car"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <td style="margin-left: 5px;width:80px;background:green;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:green !important;" @click="addCar()" v-b-toggle.crm_project_view>{{lang.add}}</div>
                                    </td>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                    </v-col>
                    <v-col class="text-center" cols="12" md="6" sm="12" xs="12">
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="backBlack">{{ lang.add_title }}</th>
                                <th class="backBlack" style="width:80px;">{{ lang.action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in titles" :key="index">
                                <td>{{ item }}</td>
                                <td class="text-center backRed" @click="delTitles(index)" style="cursor:pointer;">
                                    {{ lang.delete }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th style="padding:2px !important;">
                                    <b-form-input class="inborder" v-model="title_text" />
                                </th>
                                <th @click="addTitles()" class="text-center backGreen" style="cursor:pointer;color:#fff;padding:3px !important;margin-top:3px;">
                                    {{ lang.add }}
                                </th>
                            </tr>
                        </tfoot>
                    </v-simple-table>
                </v-col>
                <v-col class="text-center" cols="12" md="6" sm="12" xs="12">
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="backBlack">{{ lang.terms }}</th>
                                <th class="backBlack">{{ lang.title_cond }}</th>
                                <th class="backBlack" style="width:80px;">{{ lang.action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in terms" :key="index">
                                <td style="text-wrap: wrap;white-space: pre-line !important;text-align:start">{{ item.term }}</td>
                                <td style="width: 100px;text-wrap: wrap;white-space: pre-line !important;text-align:start">{{ item.title }}</td>
                                <td class="text-center backRed" @click="delTerms(index)" style="width: 50px;cursor:pointer;">
                                    {{ lang.delete }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th style="padding:2px !important;">
                                    <b-form-textarea class="inborder" v-model="iterms"></b-form-textarea>
                                </th>
                                <th>
                                    <b-input-group>
                                        <b-form-select class="selborder" v-model="title" :options="titlesList" />
                                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                            <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </th>
                                <th @click="addTerms()" class="text-center backGreen" style="cursor:pointer;color:#fff;padding:3px !important;margin-top:3px;">
                                    {{ lang.add }}
                                </th>
                            </tr>
                        </tfoot>
                    </v-simple-table>
                </v-col>
                <v-col class="text-center" cols="12" md="6" sm="12" xs="12">
                    <b-table-simple>
                        <thead>
                            <tr>
                                <th style="padding:2px !important;" colspan="1" class="backBlack text-center">{{ lang.add_attachement }}</th>
                                <th style="padding:2px !important;" colspan="2" class="backBlack text-center">
                                    <input
                                          type="file"
                                          multiple
                                          label="lang.choose_file"
                                          style="width:98%;border:1px solid #ccc;padding:5px;color:red"
                                          ref="attached"
                                          class="inborder"
                                          @change="selectFiles()"
                                          >
                                </th>
                            </tr>
                            <tr>
                                <th style="padding:2px !important;width:120px;" class="backBlack">
                                    {{ lang.file_size }}
                                </th>
                                <th style="padding:2px !important;" class="backBlack">{{ lang.file_name }}</th>
                                <th style="padding:2px !important;width:75px;" class="backBlack">{{ lang.action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(attach,index) in attached" :key="index">
                                <td>{{ $RoundNums(parseFloat(parseFloat(attach.size)/1024)/1024,2) }} MB</td>
                                <td>{{ attach.name }}</td>
                                <td><i @click.prevent="attached.splice(index,1)" class="fas fa-trash-alt m-2" style="float:left;"></i></td>
                            </tr>
                        </tbody>
                        <tfoot>

                        </tfoot>
                    </b-table-simple>
                </v-col>
                </v-row>
                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" @click="AddContract()" variant="success" class="ma-2" style="width:100px;">{{lang.add}}</b-button>
                    </div>
                </template>
            </b-sidebar>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify'
export default{
    data() {
        return {
            customer: {
                id: 0,
                cctype: 1,
                customer_type: 1,
                full_name: '',
                company_name: '',
                crt_number: '',
                vat_number: '',
                building_no: '',
                street_number: '',
                district: '',
                city: '',
                zipcode: '',
                branch_no: '',
                address: '',
                entity_name: '',
                branch_name: '',
                po_number: '',
                po_date: '',
                request_number: ''
            },
            showcamp: false,
            showGov: false,
            titles: [],
            id: 0,
            mobile: '',
            company_name: '',
            contract_items: [],
            new_itesm: {
                item_code: '',
                item_name: '',
                item_price: '',
                type: '',
                type_name: []
            },
            contracts_cars: [],
            new_cars: {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                brand: '',
                model: '',
                car_year: '',
                color: '',
                vin: '',
                meter_car: '',
            },
            title: 0,
            terms: [],
            iterms: '',
            attached: [],
            title_text: '',
            con_type: 1,
            sd: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            ed: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear() + 1,
            },
            std: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            customersList: []
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        contract_date: function(){
            return  `${this.sd.year}-${('0'+this.sd.month).slice(-2)}-${('0'+this.sd.day).slice(-2)}`;
        },
        expire_date: function(){
            return  `${this.ed.year}-${('0'+this.ed.month).slice(-2)}-${('0'+this.ed.day).slice(-2)}`;
        },
        start_date: function(){
            return  `${this.std.year}-${('0'+this.std.month).slice(-2)}-${('0'+this.std.day).slice(-2)}`;
        },
        titlesList: function(){
            let t = [];
            for(let i=0;i<this.titles.length;i++){
                t.push({
                    text: this.titles[i],
                    value: i
                })
            }
            return t;
        },
        responses: function(){
            let t = [];
            for(let i=0;i < this.users.length;i++){
                t.push(
                    {text: this.users[i].full_name, value: this.users[i].id}
                )
            }
            return t;
        },
        taskStatus: function(){
            let t = [];
            for(let i=0;i < this.statuss.length;i++){
                let text = this.lang.langname == 'ar' ? this.statuss[i].name_ar : this.statuss[i].name_en;
                t.push(
                    {text: text, value: this.statuss[i].value}
                )
            }
            return t;
        }
    },
    methods: {
        changeCusType(id){

            if(id == 0){
                this.customer.cctype = 1;
                this.customer.customer_type = 1;
                this.showcamp = false;
                this.showGov = false;
                this.$refs._indiv.classList.remove('hideme');
                this.$refs._comps.classList.add('hideme');
                this.$refs._goves.classList.add('hideme');

                this.$refs._cInd.classList.remove('redColor');
                this.$refs._cCom.classList.remove('redColor');
                this.$refs._cGov.classList.remove('redColor');
                this.$refs._cInd.classList.remove('weightColor');
                this.$refs._cCom.classList.remove('weightColor');
                this.$refs._cGov.classList.remove('weightColor');

                this.$refs._cInd.classList.add('redColor');
                this.$refs._cCom.classList.add('weightColor');
                this.$refs._cGov.classList.add('weightColor');

            }else if(id == 1){
                this.customer.cctype = 2;
                this.customer.customer_type = 2;
                this.showcamp = true;
                this.showGov = false;
                this.$refs._comps.classList.remove('hideme');
                this.$refs._indiv.classList.add('hideme');
                this.$refs._goves.classList.add('hideme');

                this.$refs._cInd.classList.remove('redColor');
                this.$refs._cCom.classList.remove('redColor');
                this.$refs._cGov.classList.remove('redColor');
                this.$refs._cInd.classList.remove('weightColor');
                this.$refs._cCom.classList.remove('weightColor');
                this.$refs._cGov.classList.remove('weightColor');

                this.$refs._cInd.classList.add('weightColor');
                this.$refs._cCom.classList.add('redColor');
                this.$refs._cGov.classList.add('weightColor');

            }
            else if(id == 2){
                this.customer.cctype = 3;
                this.customer.customer_type = 3;
                this.showGov = true;
                this.showcamp = false;
                this.$refs._goves.classList.remove('hideme');
                this.$refs._comps.classList.add('hideme');
                this.$refs._indiv.classList.add('hideme');

                this.$refs._cInd.classList.remove('redColor');
                this.$refs._cCom.classList.remove('redColor');
                this.$refs._cGov.classList.remove('redColor');
                this.$refs._cInd.classList.remove('weightColor');
                this.$refs._cCom.classList.remove('weightColor');
                this.$refs._cGov.classList.remove('weightColor');

                this.$refs._cInd.classList.add('weightColor');
                this.$refs._cCom.classList.add('weightColor');
                this.$refs._cGov.classList.add('redColor');

            }
            this.customersList = [];
            this.getAllName();
            // this.changeCtype();
        },
        getAllName(id){
            // this.customer.mobile = "";
            if(this.customer.customerid != ''){
                return false;
            }
            this.customer.customerid = "";
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','customerInfoAll');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[mobile]',this.customer.mobile);
            post.append('data[customerid]',this.customer.customerid);
            post.append('data[customer_type]',this.customer.cctype);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    this.customersList = res.results.data;
                    if(this.customersList.length == 0){
                        return false;
                    }
                    // if(this.customer.customerid != ''){

                        this.customer = res.results.data[0]
                        this.changeCusType(parseFloat(res.results.data[0].customer_type) - 1)
                    // }
                }
            )
        },
        updatePlate(){
            this.new_cars.plate_number = this.new_cars.c1 + " " + this.new_cars.c2 + " " + this.new_cars.c3 + " " + this.new_cars.text
            this.getCar();
        },
        selectFiles(){
            const files = this.$refs.attached.files;
            this.attached = [...this.attached, ...files];
        },
        addTitles(){
            if(this.title_text == '') return false;
            this.titles.push(this.title_text);
            this.title_text = ''
        },
        delTitles(index){
            this.titles.splice(index,1)
        },
        addTerms(){
            console.log(this.iterms)
            if(this.iterms == '') return false;
            this.terms.push({
                term: this.iterms,
                title: this.titles[this.title],
                title_id: this.title
            });
            this.iterms = ''
            this.title = 0
        },
        delTerms(index){
            this.terms.splice(index,1)
        },
        resetAll(id){
            this.con_type = id;
            this.id =  0;
            // this.contract_date =   (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            // this.start_date =   (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            // this.expire_date =   (new Date(new Date(new Date().setFullYear(new Date().getFullYear() + 1)) - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.mobile =  '';
            this.company_name =  '';
            this.contract_items =  [];
            this.new_itesm =  {
                item_code:   '',
                item_name:   '',
                item_price:   '',
                type:   '',
                type_name:   []
            };
            this.contracts_cars = [];
            this.new_cars =  {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number:   '',
                brand:   '',
                model:   '',
                car_year:   '',
                color:   '',
                vin:   '',
                meter_car:   '',
            };
            this.title = 0
            this.titles = []
            this.terms = []
            this.iterms = ''
            this.attached = []
            this.title_text = ''
            this.customer = {
                id: 0,
                cctype: 1,
                customer_type: 1,
                full_name: '',
                company_name: '',
                crt_number: '',
                vat_number: '',
                building_no: '',
                street_number: '',
                district: '',
                city: '',
                zipcode: '',
                branch_no: '',
                address: '',
                entity_name: '',
                branch_name: '',
                po_number: '',
                po_date: '',
                request_number: ''
            }
        },
        loadForEdit(contract){
            this.resetAll(contract.con_type);
            this.id = contract.contract_id;
            this.con_type = contract.con_type;

            const parseDate = (str, target) => {
                if(!str) return;
                const parts = str.split('-').map(Number);
                if(parts.length !== 3) return;
                target.year = parts[0]; target.month = parts[1]; target.day = parts[2];
            };
            parseDate(contract.contract_date, this.sd);
            parseDate(contract.start_date, this.std);
            parseDate(contract.expire_date, this.ed);

            const mobile = (contract.customer_contacts && contract.customer_contacts[0]) ? contract.customer_contacts[0].mobile : '';
            this.mobile = mobile || '';
            // Reuses the existing, already-correct mobile-lookup path instead
            // of trying to reconstruct the full customer record (company
            // fields, VAT number, etc.) from what getCarContracts returns --
            // that path already fetches the real row and sets customer type.
            if(this.mobile) this.getCustomer();

            this.contract_items = (contract.contract_items || []).map((it) => ({
                item_code: it.item_code,
                item_name: it.item_name,
                item_price: it.item_price,
                type: it.type,
                type_name: [],
            }));

            this.contracts_cars = (contract.cars || []).filter((c) => c && c.id).map((c) => ({
                c1: '', c2: '', c3: '',
                text: c.plate_number,
                plate_number: c.plate_number,
                brand: c.brand,
                model: c.model,
                car_year: c.manufacturing_year,
                color: c.color,
                vin: c.vin,
                meter_car: c.meter_car || '',
            }));

            // titles/terms use a client-side index scheme (a term's title_id
            // is an INDEX into the titles array, not a real DB id -- see
            // addTerms()/titlesList above), so rebuild both from
            // contract_terms_titles' already-grouped shape in one pass to
            // keep the indexes consistent.
            this.titles = [];
            this.terms = [];
            (contract.contract_terms_titles || []).forEach((t, idx) => {
                this.titles.push(t.title_name);
                (t.terms || []).forEach((term) => {
                    this.terms.push({
                        term: term.terms,
                        title: t.title_name,
                        title_id: idx,
                    });
                });
            });
        },
        deleteCar(index) {
            this.contracts_cars.splice(index,1)
        },
        deleteItem(index) {
            this.contract_items.splice(index,1)
        },
        getCustomer(){
            const post = new FormData();
            post.append("type" , "getCustomerMob");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[mobile]",this.mobile);
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.customer =  response.data.results.data
                    if(this.customer.id != 0 && this.customer.id != ''){
                        this.changeCusType(this.customer.customer_type - 1)
                    }else{
                        this.customer.id = 0
                    }
                    // this.id =  response.data.results.data.id

                }
            })
        },
        getItem(){
            const post = new FormData();
            post.append("type" , "getItemProd");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[item_code]",this.new_itesm.item_code);
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data && response.data.results && response.data.results.data.item_name != ''){
                    this.new_itesm =  {
                        item_code: response.data.results.data.item_code,
                        item_name: response.data.results.data.item_name,
                        item_price: response.data.results.data.item_price,
                        type: response.data.results.data.type,
                        type_name: response.data.results.data.type_name
                    }
                }else{
                    let message = 'الصنف غير موجود يرجى اضافة الصنف عن طريق قائمة المخزون من ثم اصناف المخزون';
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.$parent.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
            })
        },
        getCar(){
            const post = new FormData();
            post.append("type" , "getCar");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[plate_number]",this.new_cars.plate_number);
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    let car = response.data.results.data.plate_number.split(" ")
                    this.new_cars =  {
                        c1: car[0],
                        c2:car[1],
                        c3: car[2],
                        text: car[3],
                        plate_number: response.data.results.data.plate_number,
                        brand: response.data.results.data.brand,
                        model: response.data.results.data.model,
                        car_year: response.data.results.data.car_year,
                        color: response.data.results.data.color,
                        vin: response.data.results.data.vin,
                        meter_car: '',
                    }
                }
            })
        },
        addCar(){
            let tr = true;
            Object.keys(this.new_cars).forEach(key => {
                if(key == 'vin' || key == 'meter_car'){
                    //
                }
                else if(this.new_cars[key] == ''){
                    tr = false;
                }
            })
            if(!tr){
                let message = 'يرجى اكمال بيانات السيارة حتى تستطيع المتابعة';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            this.contracts_cars.push(this.new_cars);
            this.new_cars =  {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                brand: '',
                model: '',
                car_year: '',
                color: '',
                vin: '',
                meter_car: '',
            }
        },
        addNewItem(){
            let tr = true;
            Object.keys(this.new_itesm).forEach(key => {
                if(key == 'type' || key == 'type_name'){
                    //
                }
                else if(this.new_itesm[key] == ''){
                    tr = false;
                }
            })
            if(!tr){
                if(this.id == 0){
                    let message = 'يرجى اكمال بيانات الصنف حتى تستطيع المتابعة';
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.$parent.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
            }

            this.contract_items.push(this.new_itesm);
            this.new_itesm =  {
                item_code: '',
                item_name: '',
                item_price: '',
                type: '',
                type_name: []
            }
        },
        getUsers(){
            const post = new FormData();
            post.append("type" , "getUsers");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[crm_id]",this.crm_id);
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                // console.log(response.data)
                if(response && response.data && response.data.results){
                    this.users = response.data.results.data.results
                }
            })
        },
        getStatics(){
            const post = new FormData();
            post.append("type" , "getStaticOptions");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[phrase]",'taskStatus');
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                // console.log(response.data)
                if(response && response.data && response.data.results){
                    this.statuss = response.data.results.data
                }
            })
        },
        AddContract(){
            if(this.start_date > this.expire_date){
                let message = 'تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            // if(this.id == 0){
            //     let message = 'العميل غير موجود .. يرجى اضافة العميل واضافة القد من جديد';
            //     this.$snotify.error(message, 'تنبيه', {
            //         timeout: 1000000,
            //         showProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         position: SnotifyPosition.centerCenter,
            //         buttons: [
            //             {
            //                 text: this.$parent.lang.close,
            //                 action: (toast) => {
            //                     this.$snotify.remove(toast.id);
            //                 }
            //             },
            //         ]
            //     });
            //     return false;
            // }

            if(this.customer.customer_type == 1 && this.customer.full_name == ''){
                let message = 'يجب اضافة اسم العميل';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            if(
                this.customer.customer_type == 2 &&
                (
                    this.customer.company_name == '' ||
                    this.customer.crt_number == '' ||
                    this.customer.vat_number == '' ||
                    this.customer.building_no == '' ||
                    this.customer.street_name == '' ||
                    this.customer.district == '' ||
                    this.customer.city == '' ||
                    this.customer.zipcode == '' ||
                    this.customer.branch_no == '' ||
                    this.customer.address == ''
                )
            ){
                let message = 'بيانات الشركة و العنوان الوطني مطلوبه دائما';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            if(
                this.customer.customer_type == 3 &&
                (
                    this.customer.entity_name == '' ||
                    this.customer.branch_name == ''
                )
            ){
                let message = 'اسم الجهة واسم الفرع مطلوب دائما';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            if(this.contract_items.length == 0 && this.con_type == 1){
                let message = 'لا يمكن اضافة عق بدون اصناف';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            if(this.contracts_cars.length == 0 && this.con_type == 1){
                let message = 'لا يمكن اضافة عق بدون سيارات';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }

            const post = new FormData();
            post.append("type" , "addNewContract");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[id]",this.id);
            post.append("data[mobile]",this.mobile);
            post.append("data[contract_date]",this.contract_date);
            post.append("data[expire_date]",this.expire_date);
            post.append("data[start_date]",this.start_date);
            post.append("data[con_type]",this.con_type);
            post.append("data[terms]" , JSON.stringify(this.terms))
            post.append("data[titles]" , JSON.stringify(this.titles))

            post.append("data[customer]", JSON.stringify(this.customer))

            for(let i=0;i<this.attached.length;i++){
                post.append('data[files]['+i+']',this.attached[i]);
            }
            let items = {};
            for(let i = 0;i<this.contract_items.length;i++){
                items = this.contract_items[i];
                Object.keys(items).forEach(key => {
                    post.append('data[items]['+i+']['+key+']',items[key])
                })
            }
            for(let i = 0;i<this.contracts_cars.length;i++){
                items = this.contracts_cars[i];
                Object.keys(items).forEach(key => {
                    post.append('data[cars]['+i+']['+key+']',items[key])
                })
            }
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            )
            .then((response) => {
                const res = response.data;
                let message = this.$parent.lang.addes_successfuly;
                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.$parent.getContracts();
                document.getElementById('hideContract').click();
            });

            this.message = '';
        }
    },
    created() {
        this.getUsers();
        this.getStatics();
    },
}
</script>
<style scoped>
.flexTay{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    justify-items: center;
}
.flexTay select{
    margin-inline-end: 2px;
}
.hideme{
    display:none !important;
}
.redColor {
    background: red!important;
    color: #fff!important;
}
.weightColor {
    background: #fff !important;
    color: #000 !important;
}
</style>